import { useMemo } from 'react';

import { EditingMode } from '@aline/common';
import type { DeclarativeMenuItemConfig } from 'src/components/declarative-menu';
import { useCurrentUserId } from 'src/gql';
import { PLANNED_MENU_ITEMS_FLAG } from 'src/helpers';
import { useCurrentEditingMode, useEditingDisabled } from 'src/store/document/selectors';

export const plannedOnly: Partial<DeclarativeMenuItemConfig> = {
  onClick: () => alert('This is a planned feature that is only visible in development.'),
  visible: PLANNED_MENU_ITEMS_FLAG,
};

export function useIfEditableMixin(): Partial<DeclarativeMenuItemConfig> {
  const editingDisabled = useEditingDisabled();
  return useMemo(() => ({ enabled: !editingDisabled }), [editingDisabled]);
}

export function useIfLoggedInMixin(): Partial<DeclarativeMenuItemConfig> {
  const currentUserId = useCurrentUserId();
  return useMemo(() => ({ enabled: !!currentUserId }), [currentUserId]);
}

export function useUnlessViewerMixin(): Partial<DeclarativeMenuItemConfig> {
  const editingMode = useCurrentEditingMode();
  return useMemo(() => ({ enabled: editingMode !== EditingMode.VIEWING }), [editingMode]);
}
